"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryDescription = void 0;
// MIT © 2017 azu
var DictionaryDescription = /** @class */ (function () {
    function DictionaryDescription(description) {
        this.value = description;
    }
    Object.defineProperty(DictionaryDescription.prototype, "hasValue", {
        get: function () {
            return this.value.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    return DictionaryDescription;
}());
exports.DictionaryDescription = DictionaryDescription;
//# sourceMappingURL=DictionaryDescription.js.map


//////////////////
// WEBPACK FOOTER
// ../domain/lib/Dictionary/DictionaryDescription.js
// module id = 172
// module chunks = 0